import RoomLayout from "/components/shared/layouts/RoomLayout";
import ViewHeader from "/components/shared/ViewHeader.jsx";
import {motion} from "framer-motion";
import {QuestionSvg} from '/components/shared/SvgIcons'


export default function FAQ() {
    return (
        <RoomLayout key="room" background="bg-cover bg-foyerBlurred">
        <motion.div
            initial={{opacity: 0, translateY: 500}}
            animate={{opacity: 1, translateY: 0}}
            exit={{opacity: 0, scale: 0.5}}
            className={`p-2 relative flex flex-col overflow-mx-4 mt-24 w-[90vw] 2xl:w-[60vw] h-[80vh] bg-white rounded-[16px]`}>
            <ViewHeader title="zum foyer" url="/foyer"/>
            <div className='faq text-sm xl:text-base p-8 md:p-x24 overflow-auto'>
              <h1 className="text-xl">Häufige Fragen zum Streaming</h1>
              <h2 className="text-lg">Wo schaue ich den Stream?</h2>
              <p>
                Wenn Sie ein Ticket für einen Stream erworben haben, können Sie Ihren Code 3 Stunden vor Beginn der Vorstellung im digitalen Foyer des Jungen Theater Bonn einlösen und sich das Stück im Saal ansehen. Den Link finden Sie in Ihrer Bestätigungsmail und auf Ihrem Ticket. Der Stream startet dann zur angegeben Uhrzeit.
              </p>

              <h2 className="text-lg">
                Auf welchem Endgerät kann ich den Stream schauen?
              </h2>
              <p>
                Die Streams können auf allen internetfähigen Geräten mit Internet Browser wiedergegeben werden.
              </p>

              <p>Wir empfehlen folgende Betriebssysteme:</p>
              <ul>
                <li>Windows 7 oder höher | MacOS Sierra (10.12.6) oder höher</li>
              </ul>

              <p>Wir empfehlen folgende Browser + Versionen:</p>
              <ul>
                <li>Chrome 30+ | Firefox 27+ | Microsoft Edge |Safari 9+</li>
              </ul>

              <p>
                Auf Mobilgeräten können Android (Lollipop) Version 5.0+ oder iOS Version 9.3.5+ verwendet werden.
              </p>

              <h2 className="text-lg">              
                Ist mein Internet schnell genug?
              </h2>
              <p>
                Unsere Empfehlungen:
              </p>
              <ul>
                <li>
                  1,0 Mbit pro Sekunde – Mindestens erforderliche Breitbandgeschwindigkeit 270p
                </li>
                <li>
                  2,0 Mbit pro Sekunde – Empfohlene Breitbandgeschwindigkeit 360p
                </li>
                <li>
                  3,0 Mbit pro Sekunde – Empfohlen für Standardauflösung 720p
                </li>
                <li>
                  7,0 Mbit pro Sekunde – Empfohlen für HD-Qualität 1080p
                </li>
              </ul>
              <p>
                Wie schnell Ihre Internetverbindung ist, können Sie mit einem Speedtest herausfinden.
              </p>

              <h2 className="text-lg">
                Wie kann ich die Auflösung anpassen?
              </h2>
              <p>
                Sie finden unten rechts im Player die Einstellungen zur Qualität. Standardmäßig steht diese auf auto. Sollten Sie Probleme mit dem Stream haben, so können Sie die Auflösung an dieser Stelle heruntersetzen. Folgende Auswahlmöglichkeiten gibt es: 270p, 360p, 720p, 1080p.
              </p>

              <h2 className="text-lg">
                Warum habe ich keinen Ton?
              </h2>
              <p>
                Der Ton ist nicht immer automatisch an, wenn der Stream startet. Manchmal muss er aktiv angeschalten werden. Sie finden unten links im Player das Lautsprechersymbol. Ist es durchgestrichen, so ist der Stream stummgeschaltet. Schalten Sie den Ton mit einem Klick an und verschieben Sie den Regler nach rechts, um die Lautstärke anzupassen.
              </p>

              <h3 className="text-xl mt-16">
                FRAGEN ZUM TICKET/CODE
              </h3>
              <h2 className="text-lg">
                Ich habe keine Mail mit meinem Ticket bekommen.
              </h2>
              <p>
                Schauen Sie in diesem Fall am besten erstmal im Spamordner Ihres Mailpostfachs nach. Falls die Mail auch dort nicht zu finden ist, so kontaktieren Sie uns gerne telefonisch unter (0228) 46 36 72 oder per Mail unter <a className="underline" href="mailto:info@jt-bonn.de">info@jt-bonn.de</a>.
              </p>
              <h2 className="text-lg">
                Ungültiger Code! Was bedeutet das?
              </h2>
              <p>
                Bitte prüfen Sie zunächst, ob Sie auf der richtigen Seite sind und ein Ticket für den gewünschten Termin erworben haben. Bei Streams mit mehreren Sendeterminen kann es vorkommen, dass versehentlich ein Ticket für ein falsches Datum gekauft wurde.
              </p>
              <p>
                Überprüfen Sie bitte dann nochmals Ihren Code auf Ihrem Ticket. Wir verwenden nur Kleinbuchstaben, keine Sonderzeichen und keine Leerzeichen. Am besten kopieren Sie Ihren Code einfach aus dem Ticket heraus und fügen ihn in das Eingabefenster ein.
              </p>
              <p>
                Sollten Sie immer noch Probleme haben, so kontaktieren Sie gerne den Streaming Support unter support@dringeblieben.de.
              </p>
              <h2 className="text-lg">
                Mein Code wurde bereits auf einem anderen Gerät eingelöst! Was bedeutet das?
              </h2>
              <p>
                Codes können nur für Gruppenvorstellungen mehrfach auf verschiedenen Geräten eingelöst werden. So wird vermieden, dass Codes einfach an weitere Leute weitergegeben werden. Falls Sie diese Meldung fälschlicherweise erhalten, schreiben Sie gerne eine Mail an support@dringeblieben.de mit folgenden Infos: Name, Ticketkauf-Mail, Titel des Streams. Wir setzen Ihren Code dann gerne zurück.
              </p>

              <a href="mailto:info@jt-bonn.de" className='mt-8 w-64 bg-gold rounded-full flex justify-center items-center cursor-pointer px-4'>
                {QuestionSvg()}
                <div className="font-cooper-hewitt-semibold text-white uppercase text-base px-2 pt-2 pb-1">
                  Hilfe
                </div>
              </a>

            </div>
        </motion.div>
        </RoomLayout>
    );
}
